<template>
  <div class="desp">
    <div class="desp-header">
      <div class="label">Company Name</div>
      <div class="opts">
        <el-button
          v-if="
            (detail.applymentStatus === 'REVISING' ||
              detail.applymentStatus === 'CORRECTED' ||
              detail.applymentStatus === 'ILLEGAL' ||
              detail.applymentStatus === 'AUDIT_FAIL' ||
              detail.applymentStatus === 'REFUND_APPLY_DENY' ||
              detail.applymentStatus === 'REFUND_APPLY_REJECT' ||
              detail.applymentStatus === 'ACRA_REJECTED') &&
            isApplymentAuth('company:coordinate')
          "
          @click="openEdit()"
        >
          Edit
        </el-button>
      </div>
    </div>
    <div class="desp-items-group">
      <div class="desp-items-group-title">Proposed Company Name</div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-self">
                <span class="company-name">{{ detail.proposedCompanyName1 }}</span>
                <span class="company-type">{{ detail.proposedCompanyType1 }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <!-- <div class="desp-item-label">Name2</div> -->
              <div class="desp-item-self">
                <span class="company-name">{{ detail.proposedCompanyName2 }}</span>
                <span class="company-type">{{ detail.proposedCompanyType2 }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <!-- <div class="desp-item-label">Name3</div> -->
              <div class="desp-item-self">
                <span class="company-name">{{ detail.proposedCompanyName3 }}</span>
                <span class="company-type">{{ detail.proposedCompanyType3 }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="desp-items-group">
      <div class="desp-items-group-title">MSIC Code(Maximum 3)</div>
      <div class="desp-item">
        <div class="desp-item-self">
          <template v-if="msicLabelList.length">
            <div class="lh28" v-for="(label, i) in msicLabelList" :key="'msic-' + i">{{ label }}</div>
          </template>
        </div>
      </div>
    </div>
    <div class="desp-items-group">
      <div class="desp-items-group-title">Business Description</div>
      <div class="desp-item">
        <div class="desp-item-self">{{ detail.businessDescription || "" }}</div>
      </div>
    </div>
    <!-- Nominee Director Service -->
    <div class="no-event desp-items-group" id="engageNomineeDirectorCheckbox" v-if="isNeedNomineeDirector">
      <div class="desp-items-group-title">Nominee Director Service</div>
      <div class="desp-item">
        <div class="desp-item-self">
          <el-checkbox class="checkboxCustom" :true-label="1" :false-label="0" v-model="detail.hasNomineeDirector">
            We consent to appoint one Nominee Director recommended by Estar Business Advisory Sdn. Bhd. ("EStar"), and we understand that any legal impact caused by
            the Nominee Director's action has nothing to do with EStar.
          </el-checkbox>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <edit-modal v-if="editVisible" ref="editModal" :businessType="detail.businessType" :isNeedNomineeDirector="isNeedNomineeDirector" />
  </div>
</template>

<script>
import EditModal from "./modal/Edit.vue";
export default {
  components: {
    EditModal,
  },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {
          proposedCompanyName1: "empty",
          proposedCompanyType1: "empty",
          hasNomineeDirector: null,
        };
      },
    },
    isNeedNomineeDirector: {
      type: Boolean,
    },
  },
  data() {
    return {
      dataListLoading: false,
      editVisible: false,
    };
  },
  computed: {
    msicLabelList() {
      if (!this.detail.msicCodes) return [];
      const tradeList = this.$store.state.constant.tradeData.Malaysia || [];
      return this.detail.msicCodes.split("\x1F").map(code => {
        const item = tradeList.find(i => i.value === code);
        return item ? item.label : code;
      });
    },
  },
  methods: {
    async openEdit() {
      this.editVisible = true;
      await this.$nextTick();
      this.$refs.editModal.init(this.detail);
    },
  },
};
</script>

<style lang="scss" scoped>
.company-name {
  margin-right: 10px;
  font-weight: 500;
  font-size: 17px;
}

.company-type {
  font-weight: 400;
}

.checkboxCustom {
  ::v-deep .el-checkbox__label {
    overflow-wrap: break-word !important;
    word-wrap: break-word !important;
    -ms-word-break: break-all !important;
    word-break: break-all !important;
    word-break: break-word !important;
    hyphens: auto !important;
    display: inline-grid;
    white-space: pre-line;
    line-height: 20px;
  }
}
</style>
